import company1 from "assets/images/company/1.png";
import company2 from "assets/images/company/2.png";
import company3 from "assets/images/company/3.png";
import company4 from "assets/images/company/4.png";
import company5 from "assets/images/company/5.png";
import company6 from "assets/images/company/6.png";
import OwlCarousel from "react-owl-carousel";

const options = {
  items: 6,
  margin: 24,
  dots: false,
  nav: false,
  smartSpeed: 1500,
  loop: true,
  autoplay: true,
  autoplayTimeout: 2500,
  autoplayHoverPause: true,
  responsiveClass: true,
  responsive: {
    0: {
      items: 2,
    },
    768: {
      items: 4,
    },
    1170: {
      items: 6,
    },
  },
};

const Clients = () => {
  return (
    <section className="section top-company">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="section-header text-center aos mb-5" data-aos="fade-up">
              <span className="section-subtitle">Partners & Clients</span>
              <h2 className="client-title">
                Trusted by <span>100+</span> scale-stage enterprises
              </h2>
              <p className="client-desc">
                Leading brands execute their field operations, audits, and customer acquisitions through our managed gig network.
              </p>
            </div>
          </div>
        </div>
        <OwlCarousel
          id="company-slider"
          className="owl-carousel owl-theme testimonial-slider aos"
          data-aos="fade-up"
          {...options}
        >
          <div className="company-logos">
            <img src={company1} alt="apollo-tyres" />
          </div>
          <div className="company-logos">
            <img src={company2} alt="kotak-bank" />
          </div>
          <div className="company-logos">
            <img src={company3} alt="aditya-birla" />
          </div>
          <div className="company-logos">
            <img src={company4} alt="mahindra" />
          </div>
          <div className="company-logos">
            <img src={company5} alt="oyo" />
          </div>
          <div className="company-logos">
            <img src={company6} alt="paytm" />
          </div>
          <div className="company-logos">
            <img src={company1} alt="apollo-tyres" />
          </div>
        </OwlCarousel>
      </div>
    </section>
  );
};
export default Clients;
